module.exports = __webpack_public_path__ + "static/media/group.59c54792.svg";